var _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMmyEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3633_6663)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3633_6663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24C30.6274 24 36 18.6274 36 12C36 5.37258 30.6274 0 24 0C17.3726 0 12 5.37258 12 12C12 18.6274 17.3726 24 24 24Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1856 3.46875L24.0713 3.85969V15.1978L24.1856 15.3122L29.4488 12.2016L24.1856 3.46875Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1856 3.46875L18.9225 12.2016L24.1856 15.3122V9.80906V3.46875Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1856 16.3088L24.1209 16.3884V20.4272L24.1856 20.6166L29.4525 13.2L24.1856 16.3088Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1856 20.6165V16.3087L18.9225 13.199L24.1856 20.6165Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1856 15.3122L29.4488 12.2016L24.1856 9.80908V15.3122Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9225 12.2016L24.1856 15.3122V9.80908L18.9225 12.2016Z",
    fill: "#393939"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3633_6663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61121 20.6592C8.61121 20.6592 9.69745 19.9123 12.0072 19.9123C14.317 19.9123 15.4037 20.6592 15.4037 20.6592C15.4037 20.6592 15.0869 21.0605 14.7062 21.1805C14.3256 21.3005 13.8187 21.1877 13.1846 21.6384C12.5506 22.0891 12.0072 22.0401 12.0072 22.0401C12.0072 22.0401 11.4638 22.0881 10.8302 21.6384C10.1966 21.1886 9.68881 21.3 9.30817 21.1805C8.92753 21.0609 8.61121 20.6592 8.61121 20.6592Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2022 4.45103C10.5456 4.41503 9.6144 4.49375 9.0576 4.29599C8.10672 3.95999 7.9536 3.61967 7.14864 3.78863C6.56112 3.91199 6.42144 4.37231 6.36336 4.84031C7.788 4.58447 8.604 4.91519 8.604 4.91519C6.5568 5.13359 5.8632 5.68751 5.82 5.72207C5.76594 5.77055 5.72092 5.82824 5.68704 5.89247C5.6208 6.03311 5.67216 6.08447 5.68416 6.36191C8.52864 5.49791 10.801 6.09791 10.801 6.09791C8.72736 6.14591 6.78864 6.50639 4.93344 7.40735L5.20608 8.36207C6.912 7.74719 7.872 8.18495 7.872 8.18495C6.85265 8.43065 5.87011 8.80959 4.94976 9.31199L5.12496 9.75455C4.72944 10.0584 4.40496 11.1921 4.40496 11.1921C4.30896 10.5792 4.69296 9.73391 4.69296 9.73391C3.88992 9.78191 3.58896 10.5441 3.58896 11.1782C3.58896 11.8123 3.99552 12.528 4.48848 12.9936C4.98144 13.4592 5.09424 13.9728 5.09424 13.9728C5.46816 12.9509 4.74192 12.8688 4.93968 11.6549C5.13744 10.4409 6.59472 9.79535 6.59472 9.79535C6.29549 9.72946 5.99177 9.68598 5.68608 9.66527C6.31344 9.56927 6.75264 8.56415 10.6392 11.0889C14.5258 13.6137 16.9325 11.0597 18.2232 10.2869C18.6072 10.6003 19.0085 11.0597 19.1054 11.6549C19.3027 12.8669 18.5774 12.9509 18.9504 13.9728C18.9504 13.9728 19.0632 13.4587 19.5562 12.9936C20.0491 12.5285 20.4581 11.8099 20.4581 11.1763C20.4581 10.5427 20.1552 9.78143 19.3517 9.73199C19.3517 9.73199 19.7395 10.5773 19.6397 11.1902C19.6397 11.1902 19.3037 10.0142 18.8966 9.73679L19.1102 9.19823L18.912 9.05711C16.1448 7.37951 12.0072 7.43999 12.0072 7.43999C16.0152 7.08767 18.8453 8.37983 18.8453 8.37983L19.081 7.41071L18.3552 7.05599C18.3552 7.05599 18.3869 6.36431 18.2669 6.11039C18.1963 5.96063 17.9904 5.81327 17.8349 5.71775C16.3272 5.05583 13.7333 4.91519 13.7333 4.91519C16.0426 4.70159 17.1893 4.84415 17.6515 4.93967C17.5714 4.45295 17.3635 3.73487 16.8418 3.62495C16.5 3.55295 16.2754 3.57263 16.057 3.64559C15.961 3.53567 15.6638 3.21599 15.3178 3.10703C14.8973 2.97455 14.3366 3.09887 13.6378 2.60063C12.9389 2.10239 12.336 2.15711 12.336 2.15711C12.336 2.15711 11.7355 2.10287 11.0347 2.60111C10.3339 3.09935 9.77328 2.97503 9.35472 3.10751C8.93616 3.23999 8.58384 3.68351 8.58384 3.68351C8.58384 3.68351 9.42816 4.26335 11.2056 4.45151L11.2022 4.45103Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0072 19.5254C12.0072 19.5254 10.0344 19.5326 9.08306 19.8705C8.13169 20.2085 7.97906 20.5469 7.1741 20.3779C6.5861 20.2541 6.46129 19.7347 6.40321 19.2662C7.82785 19.5225 8.60402 19.0881 8.60402 19.0881C6.55681 18.8693 5.86322 18.3153 5.82002 18.2813C5.76595 18.2328 5.72093 18.1751 5.68706 18.1109C5.62082 17.9697 5.64289 17.8757 5.65489 17.5987C8.49986 18.4617 10.8 17.904 10.8 17.904C8.72641 17.856 6.7877 17.4955 4.9325 16.5945L5.21522 15.5342C6.99121 15.9797 7.86961 15.8184 7.86961 15.8184C6.85061 15.5732 5.86838 15.1948 4.94833 14.6928L5.17202 14.1288C8.04577 15.3009 15.9663 15.3009 18.84 14.1288L19.1079 14.8051L18.912 14.9457C16.1448 16.6257 12.0072 16.5653 12.0072 16.5653C16.0152 16.9176 18.8453 15.6254 18.8453 15.6254L19.081 16.5945L18.3552 16.9469C18.3552 16.9469 18.4469 17.8555 18.3269 18.1094C18.2563 18.2587 18.0504 18.4061 17.8949 18.5016C16.3872 19.164 13.7333 19.0877 13.7333 19.0877C16.0426 19.3013 17.1715 19.3253 17.6319 19.2317C17.5517 19.7184 17.365 20.2694 16.8418 20.3798C16.0383 20.5488 15.8818 20.2109 14.9323 19.8725C13.9829 19.5341 12.0082 19.5273 12.0082 19.5273L12.0072 19.5254Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.716 11.7806C7.716 11.7806 7.3488 12.6634 8.06832 13.0157C8.78784 13.368 10.595 13.1899 10.595 13.1899C10.595 13.1899 9.02832 12.035 7.71504 11.7806H7.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6718 12.6869C16.6718 12.6869 16.8125 13.4194 16.2067 13.5744C15.601 13.7295 14.2483 13.3071 14.2483 13.3071C14.2483 13.3071 15.6288 12.672 16.6718 12.6869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2446 7.45154C19.2446 7.45154 20.6146 7.5413 21.4488 8.00882C22.1722 8.41346 22.8763 9.34562 22.8763 9.34562C22.8763 9.34562 21.8429 9.67106 21.5213 10.0493C21.2261 10.3978 21.1651 10.5557 21.1651 10.5557C21.1651 10.5557 20.401 9.00866 19.0243 8.44034L19.2446 7.45154Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9752 20.2392C16.9752 20.2392 17.6539 20.8339 18.2592 21.0072C18.7838 21.1551 19.5446 21.0495 19.5446 21.0495C19.5446 21.0495 19.2153 20.4178 19.2417 20.0923C19.2662 19.7928 19.3113 19.6911 19.3113 19.6911C18.7339 19.6113 18.1692 19.4571 17.6313 19.2322L16.9752 20.2392Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93392 14.0025C4.93392 14.0025 3.90144 14.9078 2.9808 15.168C2.18304 15.3926 1.02576 15.2318 1.02576 15.2318C1.02576 15.2318 1.52688 14.2704 1.488 13.776C1.45056 13.3209 1.38192 13.1659 1.38192 13.1659C1.38192 13.1659 3.01632 13.7198 4.39152 13.1481L4.93392 14.0025Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49599 3.59522C8.49599 3.59522 7.73087 3.03458 7.41791 2.45234C7.14671 1.94834 7.08191 1.14338 7.08191 1.14338C7.08191 1.14338 7.80527 1.33538 8.13311 1.23602C8.43455 1.14242 8.52863 1.0733 8.52863 1.0733C8.52863 1.0733 8.39999 2.25842 8.99039 3.10034L8.49599 3.59522Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3633_6663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3633_6663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3633_6663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmyEth);
export default __webpack_public_path__ + "static/media/MMY-ETH.d2c327294ab9986ff29aa557feabc0c8.svg";
export { ForwardRef as ReactComponent };